import React, { useCallback, useEffect, useState } from 'react';
import { createPortal } from 'react-dom';
import { useDispatch, useSelector } from 'react-redux';
import Cookies from 'js-cookie';
import { cn } from '@bem-react/classname';
import { sendStats, checkStats } from '../../actions/actionsStatistic';
import {
  CookieNames,
  CookieStateValues,
  HOURS_TO_REJECT,
  MS_IN_HOUR,
} from '../../constants/cookies';

import './PPPortal.sass';

const getCookiePP = () => {
  const cookieState = Cookies.get(CookieNames.PP_STATE);
  const cookieDate = Cookies.get(CookieNames.PP_DATE);

  return [cookieState, cookieDate];
};

const parseCookieDate = (cookieDate) => (cookieDate
  ? Number(String(cookieDate).trim()) || 0 : 0);

function PPPortal({ text }) {
  const mcn = cn('PPPortal');
  const dispatch = useDispatch();
  const [showBanner, setShowBanner] = useState(false);
  const portalEl = document.getElementById('pp-portal');
  const data = useSelector((state) => state.data);
  const { status, loading } = useSelector((state) => state.stats);

  const onPPBtnClick = useCallback((state) => {
    const cookiesSet = () => {
      Cookies.set(
        CookieNames.PP_STATE,
        state
          ? CookieStateValues.accepted
          : CookieStateValues.rejected,
      );
      Cookies.set(CookieNames.PP_DATE, Date.now().toString());
    };

    setShowBanner(false);

    cookiesSet();

    if (data?.user) {
      try {
        dispatch(
          sendStats({
            msisdn: data.user.msisdn,
            accepted: state,
            timestamp: Date.now(),
          }),
        );
      } catch (e) {
        console.error('Ошибка отправки статистики:', e);
        cookiesSet();
      }
    }
  }, [data]);

  const checkWithCookies = useCallback(() => {
    const [cookieState, cookieDate] = getCookiePP();

    if (!cookieState) {
      setShowBanner(true);
      return;
    }

    if (cookieState === CookieStateValues.accepted) {
      setShowBanner(false);
      return;
    }

    if (cookieState === CookieStateValues.rejected) {
      if (!cookieDate) {
        setShowBanner(true);
        return;
      }

      const savedDate = parseCookieDate(cookieDate);
      const hoursPassed = (Date.now() - savedDate) / MS_IN_HOUR;
      setShowBanner(hoursPassed > HOURS_TO_REJECT);
      return;
    }

    setShowBanner(true);
  }, []);

  useEffect(() => {
    if (!data?.user) return;

    const [cookieState, cookieDate] = getCookiePP();

    if (cookieState && cookieDate) {
      sendStats({
        msisdn: data.user.msisdn,
        accepted: Number(cookieState) === 1,
        timestamp: parseCookieDate(cookieDate),
      });
    }
  }, [data]);

  useEffect(() => {
    if (!data?.user) {
      checkWithCookies();

      return;
    }

    try {
      dispatch(checkStats(data.user.msisdn));
    } catch (error) {
      checkWithCookies();
    }
  }, [data]);

  useEffect(() => {
    if (status) {
      setShowBanner(status.show_banner);
    } else {
      checkWithCookies();
    }
  }, [status]);

  if (loading || !showBanner || !text) return null;

  return portalEl ? createPortal(
    <div className={mcn('Container')}>
      <div className={mcn('Wrapper')}>
        <div className={mcn('Text')} dangerouslySetInnerHTML={{ __html: text }} />
        <div className={mcn('ButtonsWrapper')}>
          <button
            className={mcn('Button')}
            onClick={() => onPPBtnClick(false)}
            type="button"
          >
            Не принимаю
          </button>
          <button
            className={mcn('Button', { accept: true })}
            onClick={() => onPPBtnClick(true)}
            type="button"
          >
            Принимаю
          </button>
        </div>
      </div>
    </div>,
    portalEl,
  ) : null;
}

PPPortal.defaultProps = {
  text: '',
};

export default PPPortal;
